import { makeVar } from '@apollo/client'

export const privacyModeActiveVar = makeVar(false)
